<template>
  <div class="detail-page">
    <div class="detail-title">授权信息</div>
    <el-table :data="detailData">
      <el-table-column label="序号">
        <template slot-scope="scope">{{scope.row.sortNumber}}</template>
      </el-table-column>
      <template v-for="column in columns">
        <el-table-column
          v-if="column.prop === 'licenseStatusName'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.licenseStatusName == '已生成'"
              style="color: #1db163"
            >
              {{ scope.row.licenseStatusName
              }}
            </div>
            <div
              v-else-if="scope.row.licenseStatusName == '已激活'"
              style="color: #4875f6"
            >
              {{ scope.row.licenseStatusName
              }}
            </div>
            <div v-else>{{ scope.row.licenseStatusName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.prop === 'effectiveDays'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.effectiveDays == -1 ? '永久' : scope.row.effectiveDays
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="column.prop"
          v-bind="column"
        ></el-table-column>
      </template>
    </el-table>
    <div class="detail-title" style="margin-left:10px;margin-top:20px;">用户信息</div>
    <el-form label-position="left" label-width="150px" v-loading="loading">
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="最终客户单位名称："><span class="user-info-style">{{userInfo.finalCustomerName || '--'}}</span></el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="申请单位名称："><span class="user-info-style">{{userInfo.companyName || '--'}}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="申请联系人姓名："><span class="user-info-style">{{userInfo.userName || '--'}}</span></el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="申请联系人电话："><span class="user-info-style">{{userInfo.phone || '--'}}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="申请联系人E-mail："><span class="user-info-style">{{userInfo.email || '--'}}</span></el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="申请联系人邮编："><span class="user-info-style">{{userInfo.postCode || '--'}}</span></el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="申请联系人地址："><span class="user-info-style">{{userInfo.address || '--'}}</span></el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="项目名称："><span class="user-info-style">{{userInfo.projectName || '--'}}</span></el-form-item>
        </el-col>
      </el-row>
    </el-form>
     <el-table :data="detailData">
      <el-table-column label="序号" fixed="left">
        <template slot-scope="scope">{{scope.row.sortNumber}}</template>
      </el-table-column>
      <el-table-column label="获取激活信息" min-width="200" fixed="left">
        <div class="getActiveClass" @click="getActiveFile()">
            <img class="getActiveImg" src="../../../assets/img/save.svg"  alt="">
            <span class="getActiveText">获取激活文件</span>
        </div>
      </el-table-column>    
      <template v-for="column in columnsB">
        <el-table-column
          v-if="column.prop === 'licenseStatusName'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.licenseStatusName == '已生成'"
              style="color: #1db163"
            >
              {{ scope.row.licenseStatusName
              }}
            </div>
            <div
              v-else-if="scope.row.licenseStatusName == '已激活'"
              style="color: #4875f6"
            >
              {{ scope.row.licenseStatusName
              }}
            </div>
            <div v-else>{{ scope.row.licenseStatusName }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.prop === 'effectiveDays'"
          :key="column.prop"
          v-bind="column"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.effectiveDays == -1 ? '永久' : scope.row.effectiveDays
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="column.prop"
          v-bind="column"
        ></el-table-column>
      </template>
    </el-table>
    <dialog-common
      v-if="dialogCommonVisible"
      :visible.sync="dialogCommonVisible"
      title="获取激活文件"
      @handleConfirm="handleConfirm"
      @handleClose="handleClose"
    >
     <div><span style="margin-right:10px;">请选择激活文件获取方式：</span>
        <el-checkbox-group style="display:inline-block" v-model="checkList"><el-checkbox label="下载激活文件"></el-checkbox><el-checkbox label="邮件发送激活文件"></el-checkbox></el-checkbox-group>
     </div>
    </dialog-common>
  </div>
</template>
<script>
import zgyLicenseReq from '~/request/zgyLicenseReq';
import h3cServerTable from '~/components/h3c-server-table-get.vue';
import DialogCommon from "./Dialog/DialogCommon";
export default {
  components: {
    h3cServerTable,
    DialogCommon
  },
  data() {
    return {
      otherColumn: {
        selection: {
          'reserve-selection': true,
          width: 45,
        },
        columnIndex: {
          width: 50,
        },
      },
      dialogCommon: false,
      loading: false,
      url: '',
      defaultParam: {},
      columns: [
        {
          prop: 'licenseNo',
          label: '授权码',
          minWidth: '300',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseSn',
          label: '软件条码',
          minWidth: '180',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'displayFeatureName',
          label: '产品型号',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'chineseDesc',
          label: '产品描述',
          minWidth: '130',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseStatusName',
          label: '授权码状态',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseTypeName',
          label: '授权码类型',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'effectiveDays',
          label: '剩余有效时限（天）',
          minWidth: '160',
          'show-overflow-tooltip': true,
          sortable: true,
        },
      ],
      columnsB: [
        {
          prop: 'deviceTag',
          label: '设备标识',
          minWidth: '200',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseNo',
          label: '授权码',
          minWidth: '300',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseSn',
          label: '软件条码',
          minWidth: '180',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'displayFeatureName',
          label: '产品型号',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'chineseDesc',
          label: '产品描述',
          minWidth: '130',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseStatusName',
          label: '授权码状态',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'licenseTypeName',
          label: '授权码类型',
          minWidth: '110',
          'show-overflow-tooltip': true,
          sortable: true,
        },
        {
          prop: 'effectiveDays',
          label: '剩余有效时限（天）',
          minWidth: '160',
          'show-overflow-tooltip': true,
          sortable: true,
        }],
      detailData:[],
      userInfo:{},
      dialogCommonVisible:false,
      checkList:['下载激活文件'],
      activeFileUrl:''
    };
  },

  created() {
    let id = sessionStorage.getItem('activeId');
    zgyLicenseReq.getDetail(id).then(res=>{
        if(res.status){
            let detailInfo = res.res.productDetailEntity;
            let deviceInfo = res.res.deviceFileEntity;
            this.activeFileUrl = res.res.activateFileEntity&&res.res.activateFileEntity.url||'';
            this.detailData = [{
                sortNumber:sessionStorage.getItem('sortNumber'),
                licenseNo:detailInfo.licenseNo,
                licenseSn:detailInfo.licenseSn,
                displayFeatureName:detailInfo.displayFeatureName,
                chineseDesc:detailInfo.chineseDesc,
                licenseStatusName:detailInfo.licenseStatusName,
                licenseTypeName:detailInfo.licenseTypeName,
                effectiveDays:detailInfo.effectiveDays,
                deviceTag:deviceInfo.tag
            }];
            this.userInfo = res.res.customerEntity;
        }
    })
  },
  methods: {
    getActiveFile(){
      this.dialogCommonVisible = true;
      this.checkList = ['下载激活文件'];
    },
    //激活文件弹框
    handleClose(){
      this.dialogCommonVisible = false;
    },
    handleConfirm(){
      if(!this.checkList.length){
        this.handleClose();
      }else{
        if(this.checkList.includes('下载激活文件')){
          window.location.href = this.activeFileUrl;
        }
        if(this.checkList.includes('邮件发送激活文件')){    
          let productDetailId = sessionStorage.getItem('activeId');
          zgyLicenseReq.sendEmailForDetail(productDetailId).then(res=>{
            if(res.status){
              this.handleClose();
              this.$notify({
                title: '成功',
                message: '邮件发送激活文件成功',
                type: 'success',
              });
            }else{
              this.$notify({
                title: '失败',
                message: res.msg || '邮件发送激活文件失败',
                type: 'error',
              });
            }
          })
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detail-page {
  padding: 16px;
}
.detail-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom:20px;
}
.user-info-style{
  color:#606266;
}
.getActiveClass{
      display: flex;
      align-items: center;
      cursor: pointer;
      .getActiveImg{
        margin-right: 10px;
      }
      .getActiveText{
        border: 1px solid #E6E8EC;
        padding: 2px 10px;
        background-color: #fff;
      }
    }
</style>